








































import { Component, PropSync } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import FileUtil from '@/util/FileUtil';
import PrimaryButton from '@/components/Buttons/PrimaryButton/index.vue';
@Component({
  components: {
    PrimaryButton,
  },
})
export default class DropzoneList extends mixins(FileUtil) {
  @PropSync('documents', {}) documentsSync!: any;

  public onDelete(document: any) {
    this.$emit('delete', document);
  }

  public onChange(value: any, document: any) {
    this.$emit('update', value, document);
  }

  public onDownload(doc: any) {
    if (doc) {
      const { base64Encoded, name } = doc;
      this.downloadDocument(base64Encoded, name);
    }
  }

  public onSave() {
    this.$emit('save');
  }
}
